module.exports = __webpack_public_path__ + "static/adult_red_dragon-566ee565920e97ec859e7a689746dc28.png";